<template><div></div></template>
<script>
import { eventBus } from "@/main";
export default {
    name: "ToastHandler",
    created() {
        eventBus.$on("toast", (config) => {
            console.log(`EventBus.on("toast")`, config);
            
            this.$bvToast.hide("wob_toast");

            this.$bvToast.toast(config.message, {
                id: "wob_toast",
                toaster: config.position ?? "b-toaster-top-center",
                variant: config.variant ?? "info",
                autoHideDelay: config.duration ?? 3500,
                solid: true,
                appendToast: false,
                noCloseButton: config.noCloseButton || false
            });
        });
    }
};
</script>
<style>
    .b-toaster {
        top: 2rem;
    }
    .toast-body {
        font-size: 1.25rem;
        text-align: center;
    }
</style>